<template>
    <div class="d-flex flex-row align-items-center justify-content-center fullscreen">
        <div class="col-12" style="max-width: 24rem">
           <card>
               <template #header>
                   <p class="mb-0 fs-3 fw-bold">{{ $t('login.title') }}</p>
               </template>

               <form
                   enctype="application/x-www-form-urlencoded"
                   autocomplete="off"
                   @submit.prevent="onSubmit"
               >
                   <!-- email -->
                   <div class="form-group mb-3">
                       <label for="email">
                           {{ $t('login.email') }}
                       </label>
                       <input
                           type="email"
                           id="email"
                           class="form-control"
                           :class="[form.errors.email ? 'is-invalid' : '']"
                           autocomplete="email"
                           autofocus
                           v-model="form.email"
                           :placeholder="$t('login.email')"
                       >
                       <form-error v-if="form.errors.email">
                           {{ form.errors.email }}
                       </form-error>
                   </div>

                   <!-- password -->
                   <div class="form-group mb-3">
                       <label for="password">{{ $t('login.password') }}</label>

                       <input
                           id="password"
                           type="password"
                           class="form-control"
                           :class="[form.errors.email ? 'is-invalid' : '']"
                           v-model="form.password"
                           required
                           autocomplete="current-password"
                           :placeholder="$t('login.password')"
                       >
                       <formError v-if="form.errors.password">
                           {{ form.errors.password }}
                       </formError>
                   </div>

                   <!-- remember -->
                   <div class="form-group mb-3">
                       <div class="form-check">
                           <input
                               class="form-check-input"
                               type="checkbox"
                               v-model="form.remember"
                               id="remember"
                           >
                           <label
                               class="form-check-label"
                               for="remember"
                           >
                               {{ $t('login.remember') }}
                           </label>
                       </div>
                   </div>

                   <!-- submit -->
                   <div class="row mb-0">
                       <div class="col-12 text-end">
                           <button
                               type="submit"
                               class="btn btn-primary"
                               :disabled="form.processing"
                           >
                               {{ $t('login.submit_button') }}
                           </button>
                       </div>
                   </div>
               </form>
           </card>
        </div>
    </div>
</template>

<script setup lang="ts">
import Card from "../../components/elements/Card.vue";
import FormError from '../../components/elements/FormError.vue'
import { useForm } from '@inertiajs/vue3'

const form = useForm({
    email: null,
    password: null,
    remember: false
})

const onSubmit = () => {
    form.post('/login')
}

</script>

<style scoped>
    .fullscreen{
        min-height: calc(100vh - 3rem);
    }
</style>
